// extracted by mini-css-extract-plugin
export default {"root":"Canvas_root__VxRhL","wrapper":"Canvas_wrapper__K7Zak","canvas":"Canvas_canvas__Cx-P8","canvas_absolute":"Canvas_canvas_absolute__ik1KD"};